import React, { useState } from "react";
import PropTypes from "prop-types";
import MainMenuItem from "../MainMenuItem/MainMenuItem";
import SubMenu from "../SubMenu/SubMenu";
import StockData from "../StockData/StockData";
import ButtonHeader from "../ButtonHeader/ButtonHeader";
import { ReactComponent as SearchSvg } from "../../images/search.svg";
import languageDir from "../../constants/languageDir";
import SubMenuCapabilities from "../SubMenu/SubMenuCapabilities";

// const languageDirection = "ltr";

const MainMenu = ({
  navigationBlock,
  isMobile,
  buttonFocus,
  stockData,
  setChangeTheme,
  setShowDesktopSearch,
  mainSiteLink,
  languageDirection,
  typeOfMenu,
  toggleModal,
}) => {
  const { mainMenu, portalsMenu, languageMenu } = navigationBlock;
  const [currentMenu, setCurrentMenu] = useState({});
  const [showMainMenu, setShowMainMenu] = useState(true);
  const [buttonBackText, setButtonBackText] = useState("");
  // Check if menu exists.
  const checkMenu = (menu) => {
    return typeof menu !== "undefined" && Object.values(menu).length !== 0;
  };
  // Func for render menus.
  const renderMenu = (menuObject, type) =>
    checkMenu(menuObject) &&
    Object.values(menuObject).map((item) => (
      <MainMenuItem
        url={item.url}
        title={item.title}
        childrenItems={item.children}
        image={item.image}
        key={item.id}
        setCurrentMenu={setCurrentMenu}
        setShowMainMenu={setShowMainMenu}
        setButtonBackText={setButtonBackText}
        isMobile={isMobile}
        id={item.id}
        type={type}
        viewMode={item.viewMode}
        toggleModal={toggleModal}
      />
    ));
  // Render main menu.
  const mainMenuComponents = renderMenu(mainMenu);
  // Render portal menu.
  const portalsMenuComponents = renderMenu(portalsMenu);
  // Render language menu.
  const languageMenuComponents = renderMenu(languageMenu, "language");
  //  Render stock.
  const stockDataComponents =
    Object.keys(stockData).length !== 0 ? (
      <StockData stockData={stockData} />
    ) : null;

  const handleSearchButton = () => {
    setShowDesktopSearch(true);
    setChangeTheme(true);
  };
  const helpClass = `${
    languageDirection === languageDir.rtl ? "ml-lg-16" : "mr-lg-16"
  }`;
  const subMenus = (
    <div
      className={`${
        !isMobile && "d-lg-flex justify-content-end align-items-center"
      }`}
    >
      {!isMobile && <div className={helpClass}>{mainSiteLink}</div>}
      {!isMobile && stockDataComponents && (
        <div className={helpClass}>{stockDataComponents}</div>
      )}
      {portalsMenuComponents && (
        <ul className="portal-menu secondary-menu mb-lg-0" role="menu">
          {portalsMenuComponents}
        </ul>
      )}
      {languageMenuComponents && (
        <ul
          className={`language-menu secondary-menu mb-lg-0 ${
            languageDirection === languageDir.rtl
              ? "ml-lg-n20"
              : "mr-lg-n32 pr-lg-16"
          }`}
          role="menu"
        >
          {languageMenuComponents}
        </ul>
      )}
      {isMobile && <div className="mt-16">{mainSiteLink}</div>}
      {isMobile && stockDataComponents && (
        <div className="mt-16">{stockDataComponents}</div>
      )}
    </div>
  );
  return (
    <nav role="navigation" className="main-navigation d-lg-flex" aria-label="Main">
      {(currentMenu && !showMainMenu && (
        <>
          {currentMenu.viewMode !== 'menu_capabilities' && currentMenu.viewMode !== 'menu_solution' && 
            <SubMenu
              childrenItems={currentMenu}
              setShowMainMenu={setShowMainMenu}
              buttonBackText={buttonBackText}
              isMobile={isMobile}
              buttonCloseFocus={buttonFocus}
              toggleModal={toggleModal}
            />
          }
          {(currentMenu.viewMode === 'menu_capabilities' || currentMenu.viewMode === 'menu_solution') && 
            <SubMenuCapabilities
              childrenItems={currentMenu}
              setShowMainMenu={setShowMainMenu}
              currentMenu={currentMenu}
              setCurrentMenu={setCurrentMenu}
              buttonBackText={buttonBackText}
              setButtonBackText={setButtonBackText}
              isMobile={isMobile}
              buttonCloseFocus={buttonFocus}
            />
          }
        </>
      )) ||
        (showMainMenu && (
          <div
            className={`d-lg-flex mt-52 mt-lg-0 ${
              mainMenuComponents ? "flex-lg-column" : "flex-lg-row"
            }`}
          >
            {!isMobile && subMenus}
            <div
              className={`d-lg-flex ${
                !mainMenuComponents ? "ml-lg-24" : "justify-content-lg-end"
              }`}
            >
              {mainMenuComponents && (
                <ul
                  className={`main-menu mb-56 mb-lg-0 d-lg-flex justify-content-lg-start ${
                    mainMenuComponents.length > 4
                      ? "main-menu--left-align"
                      : "main-menu--right-align"
                  } ${
                    typeOfMenu === "regional"
                      ? "main-menu--regional"
                      : "main-menu--default"
                  }`}
                  role="menu"
                >
                  {mainMenuComponents}
                </ul>
              )}
              {!isMobile && (
                <ButtonHeader
                  className="popup__button popup__button--open color-transform popup__button--search-lg"
                  handleClick={handleSearchButton}
                  dataModal="modaltop"
                  ariaLabel="Open search"
                  buttonContent={<SearchSvg />}
                />
              )}
            </div>
            {isMobile && subMenus}
          </div>
        ))}
    </nav>
  );
};

export default MainMenu;

MainMenu.defaultProps = {
  navigationBlock: {},
  isMobile: false,
  buttonFocus: {},
  stockData: {},
  setChangeTheme: () => {},
  setShowDesktopSearch: () => {},
  mainSiteLink: null,
  languageDirection: languageDir.ltr,
  typeOfMenu: "default",
};

MainMenu.propTypes = {
  navigationBlock: PropTypes.object,
  isMobile: PropTypes.bool,
  buttonFocus: PropTypes.object,
  stockData: PropTypes.object,
  setChangeTheme: PropTypes.func,
  setShowDesktopSearch: PropTypes.func,
  mainSiteLink: PropTypes.object,
  languageDirection: PropTypes.string,
  typeOfMenu: PropTypes.string,
  toggleModal: PropTypes.func,
};
